import React from "react"
import { useSelector } from "react-redux"
import { selectedTaskFormSlug } from "reduxSlices/taskReportBuilderSlice"
import SelectorSection from "ReportBuilder/SelectorSection"
import ColumnOptions from "./ColumnOptions"
import Selections from "./Selections"

const ColumnSelector = () => {
  const taskFormSlug = useSelector(selectedTaskFormSlug)

  if (!taskFormSlug) return null

  const instructions = (
    <div className="space-y-2">
      <p>Which columns would you like the report to include?</p>
      <p className="text-xs text-dark">Your selections can be custom ordered by dragging and dropping</p>
    </div>
  )

  return (
    <SelectorSection
      instructionComponent={instructions}
      optionsComponent={<ColumnOptions />}
      selectionsComponent={<Selections />}
      scrollable={false}
    />
  )
}

export default ColumnSelector
